<template>
    <div class="content display-content">
        <froala-view :value="processedContent" @click="$emit('click')" />
    </div>
</template>

<script>
import { applyContentLinkTargets } from '@/utilities/contentLinks.js';
import { stripInlineTextColors } from '@/utilities/stripInlineTextColors.js';

export default {
    name: 'DisplayContent',

    props: {
        content: {
            type: String,
            required: true,
        },

        openLinksInNewTab: {
            type: Boolean,
            default: true,
        },
    },

    emits: ['click'],

    computed: {
        processedContent() {
            const withoutInlineColors = stripInlineTextColors(this.content);

            return applyContentLinkTargets(withoutInlineColors, { enabled: this.openLinksInNewTab });
        },
    },
};
</script>

<style lang="scss">
@import 'resources/scss/vendor/froala/custom_classes.scss';

.embeddedObject {
    max-width: 99% !important;
}

.fr-view {
    color: var(--text-color);
}

// Keep rendered content inside its container. Without this, a single long
// unbreakable token in the HTML (a URL, a code identifier, an AI-generated
// string) sets a wide min-content on the block, which then grows past the
// viewport and drags the whole page into a horizontal scroll. overflow-wrap
// inherits, so declaring it on the wrapper covers the Froala paragraphs too.
.display-content {
    min-width: 0;
    max-width: 100%;
    overflow-wrap: anywhere;
    word-break: break-word;

    img,
    table,
    iframe,
    video,
    pre {
        max-width: 100%;
    }

    pre {
        white-space: pre-wrap;
    }
}
</style>
